export const deepCopy = <T>(value: T): T => {
  return window.structuredClone(value);
};
